<div class="w-full h-[10px] p-[2px] bg-gray-neutral-200 rounded-sm">
  <div class="h-[6px] rounded-sm" [style]="{ width: percentUsage + '%', backgroundColor: color }"></div>
</div>
